module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    staticClass: "layoutTop"
  }), _vm._v(" "), _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "10",
      "offset-md": "1"
    }
  }, [_c('back-button'), _vm._v(" "), _c('div', {
    staticClass: "panel21 panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "content-block labelAccordionForm"
  }, [_c('f7-icon', {
    staticClass: "formIcon",
    attrs: {
      "fa": "address-book"
    }
  }), _vm._v("\n                " + _vm._s(_vm.$t('creation_forms.add_contact_group')) + "\n              ")], 1)]), _vm._v(" "), _c('b-row', {
    staticClass: "justify-content-start"
  }, [_c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-write-group-label-input', {
    attrs: {
      "isMandatory": "",
      "idLabel": _vm.$t('common.nme'),
      "placeholderValue": _vm.$t('common.nme')
    },
    model: {
      value: (_vm.label),
      callback: function($$v) {
        _vm.label = $$v
      },
      expression: "label"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "3"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('contacts.my_contacts')))]), _vm._v(" "), _c('f7-button', {
    attrs: {
      "round": "",
      "href": "/account/addContactGroupContactList/"
    }
  }, [_vm._v("\n                  " + _vm._s(this.selected.length) + " " + _vm._s(_vm.$t('common.slctd')) + "\n                ")])], 1)], 1), _vm._v(" "), _c('b-row', [(Object.keys(this.selectedDebtors).length > 0) ? _c('b-col', {
    staticClass: "form-group"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('contacts.cntcts_in_ths_grp')) + "\n              ")]) : _vm._e()], 1), _vm._v(" "), _c('b-row', [(Object.keys(this.selectedDebtors).length !== 0) ? _c('ul', {
    staticClass: " offset-sm-1 col-sm-10 list-group"
  }, _vm._l((this.selectedDebtors), function(value) {
    return _c('li', {
      key: value.id,
      staticClass: "list-group-item"
    }, [_vm._v("\n                  " + _vm._s(value.label) + "\n                ")])
  }), 0) : _vm._e()])], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "2",
      "offset-md": "9"
    }
  }, [_c('f7-button', {
    staticClass: "button-action milkyBlockBlack",
    on: {
      "click": _vm.addContactGroup
    }
  }, [_c('f7-icon', {
    attrs: {
      "fa": "save"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('common.sve')))])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "toolbarPageBottomBlank"
  })], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-84e5a392", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-84e5a392","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/contacts/CMAddContactGroup.vue
// module id = 2416
// module chunks = 2